import { ref } from 'firebase/database';
import { Reservation } from '@opanuj/shared/types';
import { useDatabase } from './useDatabase';
import { useListVals } from 'react-firebase-hooks/database';
import { withDefaultList } from './defaults';

export const useReservationsList = () => {
	const database = useDatabase();
	const [reservations, loading, error] = useListVals<Reservation>(ref(database, 'bookings'), { keyField: 'id' });
	return [withDefaultList(reservations), loading, error] as const;
}
